export interface SupportContact {
  contactType?: string;
  details?: string;
}

const isLikelyUrl = (value: string): boolean =>
  /^(https?:\/\/|\/\/|www\.|t\.me\/|wa\.me\/|wa\.link\/|instagram\.com\/|facebook\.com\/|linkedin\.com\/|twitter\.com\/|x\.com\/)/i.test(
    value.trim()
  );

const ensureProtocol = (url: string): string => {
  const trimmed = url.trim();
  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith("//")) {
    return trimmed;
  }
  return `https://${trimmed}`;
};

export const getSupportContacts = (
  domainConfig: { suppportContacts?: SupportContact[]; supportContacts?: SupportContact[] } | null | undefined
): SupportContact[] =>
  domainConfig?.suppportContacts ?? domainConfig?.supportContacts ?? [];

export const getSocialContactUrl = (
  contacts: SupportContact[] | undefined,
  contactType: string
): string => {
  const details = contacts
    ?.find((contact) => contact?.contactType === contactType)
    ?.details?.trim();

  if (!details || details.length <= 2) {
    return "";
  }

  switch (contactType) {
    case "TELEGRAM_NUMBER": {
      if (isLikelyUrl(details)) {
        return ensureProtocol(details);
      }
      const handle = details.replace(/^@/, "");
      return handle ? `https://t.me/${handle}` : "";
    }
    case "INSTAGRAM_LINK": {
      if (isLikelyUrl(details)) {
        return ensureProtocol(details);
      }
      const handle = details.replace(/^@/, "").replace(/\/+$/, "");
      return handle ? `https://www.instagram.com/${handle}` : "";
    }
    default:
      return "";
  }
};
